import { render, staticRenderFns } from "./ExchangeDetailModal.vue?vue&type=template&id=59f93737&scoped=true&"
import script from "./ExchangeDetailModal.vue?vue&type=script&lang=js&"
export * from "./ExchangeDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f93737",
  null
  
)

export default component.exports